// @flow
import {useCookies} from "react-cookie";

// stolen from https://reacttraining.com/react-router/web/example/auth-workflow
import React from 'react';
import { Route, Redirect} from 'react-router-dom';
import LIUtils from "../SUPPORT/LIUtils";
import ErrorPopup from "./ErrorPopup";

const ProtectedRoute = ({ level, children, ...rest}) => {

    const [cookies,,] = useCookies();
    return (
        <Route {...rest} render={({location}) => {
            if (LIUtils.isAuthenticatedHook(cookies)) {
                if (!level) { // no specific level require
                    return (children);
                } else if (LIUtils.UserHasLevel(cookies, level)) { // has the required level - ok to proceed
                    return (children);
                } else { // required level not found
                    if (location.pathname !== "/signin") {
                        ErrorPopup.showError("Improper Level", 
                            `<p>You need user level <b>${level}</b> to proceed.</p><p>Please login again as a user with these credentials</p>`, () => {});
                    }
                }
            }
            // get here if signin is required
            return (<Redirect to={{
                pathname: '/signin',
                state: {from: location.state?.from, to: location.state?.to}
            }}/>);
        }}/>);
}

export default ProtectedRoute;